import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as Actions from './Actions';
import { handleError } from '../../shared/ErrorCatching';
import LegalEntityList from './LegalEntityList';
import LegalEntityModal from './LegalEntityModal';
import notify from '../../shared/feedback/notifications';

class LegalEntitiesPage extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            shouldShowModal: false,
            editId: -1
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.openCreateModal = this.openCreateModal.bind(this);
        this.openEditModal = this.openEditModal.bind(this);
        this.deleteLegalEntity = this.deleteLegalEntity.bind(this);
    }

    componentDidMount(): void {
        this.props.actions.list().catch((error: any) => handleError(error));
    }

    openCreateModal(): void {
        this.setState({ editId: -1 });
        this.toggleModal();
    }

    openEditModal(id: number) {
        this.setState({ editId: id });
        this.toggleModal();
    }

    toggleModal(): void {
        this.setState({ shouldShowModal: !this.state.shouldShowModal });
    }

    deleteLegalEntity(id: number) {
        this.props.actions
            .deleteLegalEntity(id)
            .then(() => {
                notify.success(Translate('legalentities/notification/legal-entity-deleted'));
            })
            .catch((error: any) => handleError(error));
    }

    render() {
        return (
            <div>
                <h1>{Translate('legalentities/page/title/legalentities')}</h1>
                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.openCreateModal}
                    bsStyle="success"
                >
                    {Translate('legalentities/modal/title/add-legal-entity')}
                </Button>
                {this.state.shouldShowModal && (
                    <LegalEntityModal
                        editId={this.state.editId}
                        shouldShowModal={this.state.shouldShowModal}
                        closeModal={this.toggleModal}
                    />
                )}
                <LegalEntityList
                    items={this.props.legalEntities}
                    edit={this.openEditModal}
                    delete={this.deleteLegalEntity}
                />
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        legalEntities: state.legalEntities.list
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            list: () => dispatch(Actions.list()),
            deleteLegalEntity: (id: number) => dispatch(Actions.deleteLegalEntity(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LegalEntitiesPage);
